(function () {
  function setReactInputValue(input, value) {
    if (!input) return;
    var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(input, value || '');
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  }

  function getSelectedRadioValue(namePrefix) {
    var radios = document.querySelectorAll('input[type="radio"].product-input');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      var name = (radio.getAttribute('name') || '').trim();
      if (name.indexOf(namePrefix) === 0 && radio.checked) {
        return radio.value;
      }
    }
    return '';
  }

  function getDiamondTypeValue() {
    var el = document.querySelector('[data-diamond-picker-value-text]');
    return el ? el.textContent.trim() : '';
  }

  function getFormShadowRoot() {
    var host = document.querySelector('shopify-forms-embed');
    return host ? host.shadowRoot : null;
  }

  function syncFields() {
    var root = getFormShadowRoot();
    if (!root) return false;

    var metalField = root.querySelector('[data-testid="field-custom#metal_option"]');
    var euSizeField = root.querySelector('[data-testid="field-custom#eu_ring_size"]');
    var diamondOptionField = root.querySelector('[data-testid="field-custom#diamond_option"]');
    var diamondTypeField = root.querySelector('[data-testid="field-custom#diamond_type"]');

    if (!metalField && !euSizeField && !diamondOptionField && !diamondTypeField) return false;

    var ukRingSize = getSelectedRadioValue('UK Ring Size');

    setReactInputValue(metalField, getSelectedRadioValue('Metal'));
    setReactInputValue(euSizeField, ukRingSize);
    setReactInputValue(diamondOptionField, getSelectedRadioValue('Diamond'));
    setReactInputValue(diamondTypeField, getDiamondTypeValue());

    return true;
  }

  function waitForFormAndSync(attemptsLeft) {
    if (syncFields() || attemptsLeft <= 0) return;
    setTimeout(function () {
      waitForFormAndSync(attemptsLeft - 1);
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitForFormAndSync(20);

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[type="radio"].product-input')) {
        syncFields();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-diamond-picker-item]')) {
        setTimeout(syncFields, 0);
      }
    });
  });
})();
